import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import { FaMinus, FaPlus } from 'react-icons/fa';

import { CheckboxField } from 'Shared/form/CheckboxField';
import withFormikFields, { fieldHelpersPropType } from 'Shared/form/withFormikFields';
import CommonPatientFieldWrapper from './CommonPatientFieldWrapper';
import OtherDiagnosisTypeaheadField from './OtherDiagnosisTypeaheadField';
import SectionTitleStyle from './SectionTitleStyle';

const OtherDiagnosesForm = ({
    fieldValues: { noKnownMedicalConditions, otherCondition: otherConditions },
    fieldHelpers: {
        otherCondition: { setValue },
    },
}) => {
    return (
        <CommonPatientFieldWrapper fieldName="otherDiagnoses">
            {(commonProps) => (
                <div>
                    <SectionTitleStyle>
                        <h2>Other Diagnoses</h2>
                    </SectionTitleStyle>

                    <CheckboxField
                        fieldName="noKnownMedicalConditions"
                        label="No known other diagnoses"
                        disabled={commonProps.disabled}
                    />

                    {!noKnownMedicalConditions && (
                        <>
                            {otherConditions.map((otherCondition, index) => (
                                <OtherDiagnosisTypeaheadField
                                    key={otherCondition.id || `index-${index}`}
                                    {...commonProps}
                                    fieldName={`otherCondition[${index}].text`}
                                    addonButton={
                                        <Button
                                            variant="outline-secondary"
                                            onClick={() => {
                                                const newOtherConditions = [...otherConditions];
                                                newOtherConditions.splice(index, 1);
                                                setValue(newOtherConditions);
                                            }}
                                            aria-label="Remove Other Diagnosis"
                                        >
                                            <FaMinus />
                                        </Button>
                                    }
                                />
                            ))}

                            {!commonProps.disabled && (
                                <Button
                                    variant="link"
                                    onClick={() => {
                                        setValue([...otherConditions, {}]);
                                    }}
                                >
                                    <FaPlus /> Add Other Diagnosis
                                </Button>
                            )}
                        </>
                    )}
                </div>
            )}
        </CommonPatientFieldWrapper>
    );
};

OtherDiagnosesForm.propTypes = {
    fieldValues: PropTypes.shape({
        noKnownMedicalConditions: PropTypes.bool,
        otherCondition: PropTypes.arrayOf(PropTypes.shape({})),
    }).isRequired,
    fieldHelpers: fieldHelpersPropType.isRequired,
};

export default withFormikFields({
    WrappedComponent: OtherDiagnosesForm,
    fieldNames: ['noKnownMedicalConditions', 'otherCondition'],
});
